export default __webpack_public_path__ + "static/cookie-240ec3507cc1511b36446fc38927cc62.png";